import { createTheme } from '@mui/material/styles';
import {
  COLOR_ERROR,
  COLOR_ERROR_CONTRAST,
  COLOR_MAIN_HIGHLIGHT,
  COLOR_MAIN_HIGHLIGHT_TEXT,
  COLOR_PRIMARY,
  COLOR_PRIMARY_CONTRAST,
  COLOR_PROGRESS,
  COLOR_PROGRESS_CONTRAST,
  COLOR_SECONDARY,
  COLOR_SECONDARY_CONTRAST,
  COLOR_SUCCESS,
  COLOR_SUCCESS_CONTRAST,
  COLOR_WARNING,
  COLOR_WARNING_CONTRAST,
  LIGHT_GREY,
  PRIMARY_TEXT_COLOR,
  SECONDARY_TEXT_COLOR
} from './colors';
import { NAVIGATION_BAR_HEIGHT } from './layout';

// Custom theme to overwrite default MuiTheme
const customTheme = createTheme({
  palette: {
    background: {
      default: LIGHT_GREY
    },
    primary: {
      main: COLOR_PRIMARY,
      contrastText: COLOR_PRIMARY_CONTRAST
    },
    secondary: {
      main: COLOR_SECONDARY,
      contrastText: COLOR_SECONDARY_CONTRAST
    },
    warning: {
      main: COLOR_WARNING,
      contrastText: COLOR_WARNING_CONTRAST
    },
    error: {
      main: COLOR_ERROR,
      contrastText: COLOR_ERROR_CONTRAST
    },
    success: {
      main: COLOR_SUCCESS,
      contrastText: COLOR_SUCCESS_CONTRAST
    },
    text: {
      primary: PRIMARY_TEXT_COLOR,
      secondary: SECONDARY_TEXT_COLOR
    },
    progress: {
      main: COLOR_PROGRESS,
      contrastText: COLOR_PROGRESS_CONTRAST
    }
  },
  typography: {
    h1: {
      fontWeight: 500,
      fontSize: '2rem'
    },
    h2: {
      fontWeight: 500,
      fontSize: '1.714rem'
    },
    h3: {
      fontWeight: 500,
      fontSize: '1.429rem'
    },
    h4: {
      fontWeight: 500,
      fontSize: '1.143rem'
    },
    body1: {
      fontWeight: 400,
      fontSize: '1rem'
    },
    body2: {
      fontWeight: 500,
      fontSize: '1rem'
    },
    subtitle1: {
      fontSize: '0.857rem',
      fontWeight: 500
    },
    subtitle2: {
      fontSize: '0.857rem',
      fontWeight: 400
    },
    caption: {
      fontSize: '0.857rem'
    }
  },
  overrides: {
    MuiDrawer: {
      paper: {
        background: COLOR_MAIN_HIGHLIGHT,
        color: COLOR_MAIN_HIGHLIGHT_TEXT
      },
      paperAnchorTop: {
        marginTop: NAVIGATION_BAR_HEIGHT
      }
    },
    MuiInputBase: {
      input: {
        '&:-webkit-autofill': {
          transitionDelay: '9999s',
          transitionProperty: 'background-color, color'
        }
      }
    },
    MuiPaper: {
      elevation2: {
        boxShadow: '0px 1px 8px rgba(17, 17, 26, 0.1), 0px 8px 24px rgba(17, 17, 26, 0.1)',
        borderRadius: '4px'
      },
      elevation3: {
        boxShadow: '0px 8px 32px rgba(17, 17, 26, 0.03)',
        borderRadius: '4px'
      }
    }
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          boxShadow: '0px 4px 16px 0px rgba(17, 17, 26, 0.05), 0px 8px 32px 0px rgba(17, 17, 26, 0.03)'
        }
      }
    }
  }
});

export default customTheme;
